export default __webpack_public_path__ + "static/media/08.390280c8.jpg";